module.exports = "pegasus/assets/theme6/small/4.jpg";